"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Highlighter = void 0;
class Highlighter {
    static highlight(str, value) {
        if (value == null) {
            return {
                score: 0,
                parts: [{ content: str, highlighted: false }],
            };
        }
        const length = value.length;
        const indexes = Highlighter.indexesOf(str, value);
        const parts = [];
        Highlighter.addContent(parts, str.substring(0, indexes[0]), false);
        for (let i = 0; i < indexes.length; i++) {
            const index = indexes[i];
            const match = str.substring(index, index + length);
            const other = str.substring(index + length, indexes[i + 1]);
            Highlighter.addContent(parts, match, true);
            Highlighter.addContent(parts, other, false);
        }
        const score = Highlighter.getScore(str, parts);
        return { score, parts };
    }
    static indexesOf(str, value) {
        const indexes = [];
        for (var i = 0; i < str.length; i++) {
            const possible = str.substr(i, value.length);
            if (Highlighter.matches(possible, value)) {
                indexes.push(i);
            }
        }
        return indexes;
    }
    static matches(a, b) {
        return a.toLowerCase() === b.toLowerCase();
    }
    static addContent(parts, content, highlighted) {
        if (content == null || content === '') {
            return;
        }
        parts.push({ content, highlighted });
    }
    static getScore(str, parts) {
        // How early in the string is the match found
        const firstMatchScore = 1 - parts.findIndex((p) => p.highlighted) / parts.length;
        // How much of the string has been matched
        let matchedCharCount = 0;
        for (const part of parts) {
            if (part.highlighted) {
                matchedCharCount += part.content.length;
            }
        }
        const matchCompletenessScore = matchedCharCount / str.length;
        return firstMatchScore * matchCompletenessScore;
    }
}
exports.Highlighter = Highlighter;
//# sourceMappingURL=highlighter.js.map